var map = {
	"./partners-1.svg": 81481,
	"./partners-10.svg": 20605,
	"./partners-11.svg": 43604,
	"./partners-12.svg": 22836,
	"./partners-2.svg": 48906,
	"./partners-3.svg": 49410,
	"./partners-4.svg": 92680,
	"./partners-5.svg": 29699,
	"./partners-6.svg": 63498,
	"./partners-7.svg": 87307,
	"./partners-8.svg": 86771,
	"./partners-9.svg": 45315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50616;